export default {
  GET_ADS_LIST_LOADING: 'GET_ADS_LIST_LOADING',
  GET_ADS_LIST_SUCCESS: 'GET_ADS_LIST_SUCCESS',
  GET_ADS_LIST_FAILED: 'GET_ADS_LIST_FAILED',
  GET_ADS_LIST_REJECT: 'GET_ADS_LIST_REJECT',

  ADD_AD_LOADING: 'ADD_AD_LOADING',
  ADD_AD_SUCCESS: 'ADD_AD_SUCCESS',
  ADD_AD_FAILED: 'ADD_AD_FAILED',
  ADD_AD_REJECT: 'ADD_AD_REJECT',

  CHANGE_AD_VISIBILITY_LOADING: 'CHANGE_AD_VISIBILITY_LOADING',
  CHANGE_AD_VISIBILITY_SUCCESS: 'CHANGE_AD_VISIBILITY_SUCCESS',
  CHANGE_AD_VISIBILITY_FAILED: 'CHANGE_AD_VISIBILITY_FAILED',
  CHANGE_AD_VISIBILITY_REJECT: 'CHANGE_AD_VISIBILITY_REJECT',

  DELETE_AD_LOADING: 'DELETE_AD_LOADING',
  DELETE_AD_SUCCESS: 'DELETE_AD_SUCCESS',
  DELETE_AD_FAILED: 'DELETE_AD_FAILED',
  DELETE_AD_REJECT: 'DELETE_AD_REJECT',

  DEFAULT_AD_LOADING: 'DEFAULT_AD_LOADING',
  DEFAULT_AD_SUCCESS: 'DEFAULT_AD_SUCCESS',
  DEFAULT_AD_FAILED: 'DEFAULT_AD_FAILED',
  DEFAULT_AD_REJECT: 'DEFAULT_AD_REJECT'
};
